import { css } from 'styled-components';
import { pxToRem } from '../../../design-tokens/style-utilities';
export const getGenericInputPaddingStyles = ({ theme, $invalid, $color, }) => {
    const paddingSpacing = Number(theme.spacing['300']);
    const borderSmallSpacing = Number(theme.borderWidth['2']);
    const borderLargeSpacing = Number(theme.borderWidth.m);
    /* We need to subtract from the paddings the border width to keep the same height and width */
    const inputPaddingDefault = paddingSpacing;
    const inputPaddingSmallBorder = paddingSpacing - borderSmallSpacing;
    const inputPaddingLargeBorder = paddingSpacing - borderLargeSpacing;
    return css `
		--input-padding-top: ${pxToRem(inputPaddingDefault)};
		--input-padding-right: ${pxToRem(inputPaddingDefault)};
		--input-padding-bottom: ${pxToRem(inputPaddingSmallBorder)};
		--input-padding-left: ${pxToRem(inputPaddingDefault)};

		padding: var(--input-padding-top) var(--input-padding-right) var(--input-padding-bottom)
			var(--input-padding-left);

		&:not(:disabled, .disabled):hover {
			--input-padding-bottom: ${pxToRem(inputPaddingLargeBorder)};
		}

		&:focus,
		&.focus {
			--input-padding-top: ${pxToRem(inputPaddingLargeBorder)};
			--input-padding-right: ${pxToRem(inputPaddingLargeBorder)};
			--input-padding-bottom: ${pxToRem(inputPaddingLargeBorder)};
			--input-padding-left: ${pxToRem(inputPaddingLargeBorder)};
		}

		${$invalid &&
        css `
			:not(:disabled, .disabled) {
				--input-padding-bottom: ${pxToRem(inputPaddingLargeBorder)};
			}
		`}

		${['error', 'success'].includes($color) &&
        css `
			--input-padding-bottom: ${pxToRem(inputPaddingLargeBorder)};
		`}
	`;
};
const colorSuccessStyles = ({ theme }) => css `
	border-color: ${theme.colors.positive.borderFormField};
	border-bottom-width: ${theme.borderWidth.m}px;
`;
const colorErrorStyles = ({ theme }) => css `
	border-color: ${theme.colors.error.borderFormField};
	border-bottom-width: ${theme.borderWidth.m}px;
`;
export const getOnLightStyles = ({ theme, $invalid, $color, }) => css `
	background-color: ${theme.colors.extralight.bgFormField};

	:not(.disabled, :disabled):hover {
		border-color: ${theme.colors.highlight.borderFormFieldHover};
		border-bottom-width: ${theme.borderWidth.m}px;
	}

	&.focus,
	&:focus-visible {
		border-color: ${theme.colors.highlight.borderFormFieldFocus};
		border-width: ${theme.borderWidth.m}px;
	}

	${$invalid &&
    css `
		:not(:disabled, .disabled) {
			border-style: solid;
			border-color: ${theme.colors.error.borderFormField};
			border-width: 0 0 ${theme.borderWidth.m}px 0;

			&:focus,
			&.focus {
				border-color: ${theme.colors.highlight.borderFormFieldFocus};
				border-width: ${theme.borderWidth.m}px;
			}
		}
	`}

	${$color === 'success' && colorSuccessStyles({ theme })}

	${$color === 'error' && colorErrorStyles({ theme })}

	${$color === 'default' &&
    css `
		border-color: ${theme.colors.medium.borderFormField};
		border-width: 0 0 ${theme.borderWidth['2']}px 0;
	`}
`;
export const getOnMediumStyles = ({ theme, $invalid, $color, }) => css `
	background-color: ${theme.colors.blanc.bgFormField};

	:not(.disabled, :disabled):hover {
		border-color: ${theme.colors.highlight.borderFormFieldOnMediumHover};
		border-bottom-width: ${theme.borderWidth.m}px;
	}

	&:focus,
	&.focus {
		border-color: ${theme.colors.highlight.borderFormFieldFocus};
		border-width: ${theme.borderWidth.m}px;
	}

	${$invalid &&
    css `
		:not(:disabled, .disabled) {
			border-style: solid;
			border-color: ${theme.colors.error.borderFormField};
			border-width: 0 0 ${theme.borderWidth.m}px 0;

			&:focus,
			&.focus {
				border-color: ${theme.colors.highlight.borderFormFieldFocus};
				border-width: ${theme.borderWidth.m}px;
			}
		}
	`}

	${$color === 'success' && colorSuccessStyles({ theme })}

	${$color === 'error' && colorErrorStyles({ theme })}

	${$color === 'default' &&
    css `
		border-color: ${theme.colors.medium.borderFormField};
		border-width: 0 0 ${theme.borderWidth['2']}px 0;
	`}
`;
export const getOnDarkStyles = ({ theme, $invalid, $color, }) => css `
	background-color: ${theme.colors.blanc.bgFormField};

	:not(.disabled, :disabled):hover {
		border-color: ${theme.colors.highlight.borderFormFieldOnDarkHover};
		border-bottom-width: 2px;
	}

	&:focus,
	&.focus {
		border-color: ${theme.colors.highlight.borderFormFieldFocus};
		border-width: ${theme.borderWidth.m}px;
	}

	${$invalid &&
    css `
		:not(:disabled, .disabled) {
			border-style: solid;
			border-color: ${theme.colors.error.borderFormFieldOnDark};
			border-width: 0 0 ${theme.borderWidth.m}px 0;

			&:focus,
			&.focus {
				border-color: ${theme.colors.highlight.borderFormFieldFocus};
				border-width: ${theme.borderWidth.m}px;
			}
		}
	`}
	${$color === 'success' &&
    css `
		border-color: ${theme.colors.positive.borderFormFieldOnDark};
		border-bottom-width: ${theme.borderWidth.m}px;
	`}
	${$color === 'error' &&
    css `
		border-color: ${theme.colors.error.borderFormFieldOnDark};
		border-bottom-width: ${theme.borderWidth.m}px;
	`}
	${$color === 'default' &&
    css `
		border-color: ${theme.colors.medium.borderFormField};
		border-width: 0 0 ${theme.borderWidth['2']}px 0;
	`}
`;
